import { render } from "./Statistic.vue?vue&type=template&id=6073b432"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Statistic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6073b432"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6073b432', __exports__)) {
    api.reload('6073b432', __exports__)
  }
  
  module.hot.accept("./Statistic.vue?vue&type=template&id=6073b432", () => {
    api.rerender('6073b432', render)
  })

}


export default __exports__